module.exports = __webpack_public_path__ + "static/img/carousel-2.755f2347.jpg";